import { Token, WETH9 } from '@uniswap/sdk-core';
import { DAI as DaiToken, UNI as UniswapUni, USDC as UniswapUSDC } from '../../../../constants/tokens';
var KIRO_Config = {
    1: {
        address: '0xB1191F691A355b43542Bea9B8847bc73e7Abb137',
        decimals: 18,
    },
    4: {
        address: '0xb678e95f83af08e7598ec21533f7585e83272799',
        decimals: 18,
    },
    5: {
        address: '0xba232b47a7dDFCCc221916cf08Da03a4973D3A1D',
        decimals: 18,
    },
};
export var KIRO = function (_a) {
    var chainId = _a.chainId;
    var KIRO_TOKEN = KIRO_Config[chainId];
    return new Token(chainId, KIRO_TOKEN.address, KIRO_TOKEN.decimals);
};
// "address": "0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF",
// "chainId": 421613,
export var ETH = function (_a) {
    var chainId = _a.chainId;
    return WETH9[chainId];
};
export var UNI = function (_a) {
    var chainId = _a.chainId;
    return UniswapUni[chainId];
};
export var USDC = function (_a) {
    var chainId = _a.chainId;
    return UniswapUSDC[chainId];
};
export var DAI = function (_a) {
    var chainId = _a.chainId;
    if (chainId === 1) {
        return DaiToken;
    }
    else {
        return {
            address: '0x75Ab5AB1Eef154C0352Fc31D2428Cef80C7F8B33',
            decimals: 18,
        };
    }
};
export var BAT = function (_a) {
    var chainId = _a.chainId;
    if (chainId === 1) {
        return {
            chainId: '1',
            address: '0x0D8775F648430679A709E98d2b0Cb6250d2887EF',
            symbol: 'BAT',
            decimals: 18,
            name: 'Basic Attention Token',
            index: 7,
            logoURI: 'https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427',
        };
    }
    else {
        return {
            chainId: '5',
            address: '0x515614aA3d8f09152b1289848383A260c7D053Ff',
            symbol: 'BAT',
            decimals: 18,
            name: 'BAT',
            index: 1,
            logoURI: 'https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427',
        };
    }
};
